/* tslint:disable */
/* eslint-disable */
/**
 * Default API
 * All endpoints not defined under specific APIs
 *
 * The version of the OpenAPI document: Latest
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface CalculateInput
 */
export interface CalculateInput {
  /**
   *
   * @type {number}
   * @memberof CalculateInput
   */
  productId?: number;
  /**
   *
   * @type {Date}
   * @memberof CalculateInput
   */
  dateFrom?: Date;
  /**
   *
   * @type {Date}
   * @memberof CalculateInput
   */
  dateTo?: Date;
  /**
   *
   * @type {string}
   * @memberof CalculateInput
   */
  packageCode: string;
  /**
   *
   * @type {string}
   * @memberof CalculateInput
   */
  targetGroupId: string;
  /**
   *
   * @type {number}
   * @memberof CalculateInput
   */
  spotLength?: number;
  /**
   *
   * @type {number}
   * @memberof CalculateInput
   */
  budget?: number;
  /**
   *
   * @type {Array<string>}
   * @memberof CalculateInput
   */
  channels: Array<string>;
}

export function CalculateInputFromJSON(json: any): CalculateInput {
  return CalculateInputFromJSONTyped(json, false);
}

export function CalculateInputFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CalculateInput {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    productId: !exists(json, "productId") ? undefined : json["productId"],
    dateFrom: !exists(json, "dateFrom")
      ? undefined
      : new Date(json["dateFrom"]),
    dateTo: !exists(json, "dateTo") ? undefined : new Date(json["dateTo"]),
    packageCode: json["packageCode"],
    targetGroupId: json["targetGroupId"],
    spotLength: !exists(json, "spotLength") ? undefined : json["spotLength"],
    budget: !exists(json, "budget") ? undefined : json["budget"],
    channels: json["channels"],
  };
}

export function CalculateInputToJSON(value?: CalculateInput | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    productId: value.productId,
    dateFrom:
      value.dateFrom === undefined ? undefined : value.dateFrom.toISOString(),
    dateTo: value.dateTo === undefined ? undefined : value.dateTo.toISOString(),
    packageCode: value.packageCode,
    targetGroupId: value.targetGroupId,
    spotLength: value.spotLength,
    budget: value.budget,
    channels: value.channels,
  };
}
